import { ActivitySquare } from 'lucide-react';
import { SessionInactiveEvent as SessionInactiveEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: SessionInactiveEventType;
}

export default function SessionInactiveEvent({ event }: Props) {
  return (
    <EventShell
      color="gray"
      icon={<ActivitySquare className="w-3.5 h-3.5" />}
      title="Session Inactive"
      timestamp={event.created_at}
    >
      <p>Visitor left the conversation</p>
      {event.payload.reason && <p>Reason: {event.payload.reason}</p>}
    </EventShell>
  );
}
